import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ index, eyebrow, title, subtitle }) => (
  <Reveal>
    <div className="mb-14 md:mb-20" data-testid={`section-${index}`}>
      <div className="flex items-center gap-4 mb-5">
        <span className="font-mono text-xs tracking-[0.3em] text-[#E2C08D]">{index}</span>
        <span className="h-px w-14 bg-[#E2C08D]/40" />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">{eyebrow}</span>
      </div>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-slate-100 leading-[1.05] tracking-tight max-w-3xl">
        {title}
      </h2>
      {subtitle && <p className="mt-5 max-w-2xl text-base md:text-lg text-slate-400 leading-relaxed">{subtitle}</p>}
    </div>
  </Reveal>
);

export const StatusBadge = ({ children, accent = "gold" }) => {
  const colors = {
    gold: "text-[#E2C08D] border-[#E2C08D]/30 bg-[#E2C08D]/10",
    sky: "text-[#38BDF8] border-[#38BDF8]/30 bg-[#38BDF8]/10",
    green: "text-[#10B981] border-[#10B981]/30 bg-[#10B981]/10",
    rose: "text-[#FB7185] border-[#FB7185]/30 bg-[#FB7185]/10",
  };
  return (
    <span className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] ${colors[accent] || colors.gold}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse-dot" />
      {children}
    </span>
  );
};
